<template>
  <div class="flex flex-col items-center">
    <div class="m-2">
      <img
        width="600"
        src="https://fantomwheelz.com/assets/images/my_garage_headline_01.png"
      />
    </div>
    <div class="text-center" v-if="!allLoaded">Loading data from blockchain... this will take a while.</div>
    <div class="">
      <div v-if="wheelzCount > 0" class="text-center text-lg md:my-4 my-1">
        You own {{ wheelzCount }} wheel(s)
      </div>
      <div class="flex flex-row flex-wrap w-full justify-center gap-4">
        <div
          class="py-2 px-4 flex flex-col w-4/5 md:w-2/5 bg-gray-500 border-8"
          style="border-color #7e838e;"
          v-for="car in myWheelz"
          :key="car.name"
        >
          <div class="w-full flex flex-row justify-center">
            <strong class="block text-white text-3xl font-bold my-2"
              >{{ car.name }}</strong
            >
          </div>
          <div class="w-full">
            <img class="w-full" :src="car.image" />
            <div class="mt-2 flex flex-col items-center justify-center">
              <div class="text-sm font-bold leading-3 mb-2">License plate</div>
              <div
                class="w-40 text-gray-800 px-2 py-1 bg-white border-4 text-center border-black rounded-md font-extrabold text-xl"
                style="font-family: Courier"
              >
                {{ car.plate }}
              </div>
            </div>
          </div>
          <div class="w-full m-1 text-gray-300">
            <ul class="grid grid-cols-2 p-2" v-if="true == false">
              <li
                v-for="value in car.attributevalues"
                :key="value.id"
                class="mt-1 mx-4 px-2"
              >
                <div class="text-yellow-500 font-bold text-xs leading-3">
                  {{ value.attribute.dispname }}
                </div>
                <div class="flex flex-row justify-between">
                  <div>{{ value.info }}</div>
                  <div class="font-bold">
                    {{ Math.round(value.rarity * 100 * 100) / 100 }}%
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { targetNetwork, getContract, apiurl } from '../walletHelpers.js'

export default {
  props: {},
  data: function () {
    return {
      contract: null,
      correctNetwork: false,
      hits: 0,
      fetchedCount: 0,
      wheelz: [],
    }
  },
  methods: {
    getMyWheelz: async function (address) {
      const mintedCount = await this.contract.mintedCount()
      let ids = []
      for (let i = 0; i < mintedCount.toNumber(); i++) {
        const checkAddress = await this.contract.ownerOf(i)
        if (checkAddress.toLowerCase() == address.toLowerCase()) {
          this.hits++
          // Get the tokenURI and find image
          const metaDataURL = await this.contract.tokenURI(i)
          if (metaDataURL != null) {
             fetch(metaDataURL)
             .then(r => r.json())
              .then((ret) => {
                this.wheelz = [...this.wheelz, ret]
                this.fetchedCount = this.fetchedCount + 1
              })
          }
        }
      }
      return ids
    },
  },
  computed: {
    myWheelz: function () {
      return this.wheelz
    },
    wheelzCount: function () {
      return this.wheelz.length
    },
    allLoaded: function() {
      return this.hits == this.fetchedCount
    }
  },
  mounted() {
    const { ethereum } = window
    ethereum.on('chainChanged', () => {
      window.location.reload() // Recommendation is to reload the page
    })
    ethereum.request({ method: 'eth_chainId' }).then((chainId) => {
      if (chainId !== targetNetwork.id) {
        alert('Please change to ' + targetNetwork.name + '!')
        this.correctNetwork = false
      } else {
        this.correctNetwork = true
        this.contract = getContract()
        // Get account
        ethereum.request({ method: 'eth_accounts' }).then((addresses) => {
          if (addresses.length == 0) {
            return
          }
          const address = addresses[0]
          this.getMyWheelz(address)
        })
      }
    })
  },
  components: {},
}
</script>



// WEBPACK FOOTER //
// src/components/MyWheelzPage.vue